import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Button,
  Spinner,
  CardHeader,
  CardTitle,
} from "reactstrap";
import AdminHeader from "components/Headers/AdminHeader";
import { useNavigate } from "react-router-dom";

//CERTIFICATE LIST (STATIC)
const certificateList = [
  {
    id: 1,
    certificateName: "Electrical Safety Training",
    issueDate: "12 Nov 2024,05:13 PM",
    status: "ACTIVE",
    image: require("assets/img/certificates_templates/certificate1.png"),
    fileUrl: require("assets/img/certificates_templates/certificate1.png"),
  },
  {
    id: 2,
    certificateName: "Advanced Cable Management",
    issueDate: "05 Jan 2023,01:53 PM",
    status: "INACTIVE",
    image: require("assets/img/certificates_templates/certificate2.png"),
    fileUrl: require("assets/img/certificates_templates/certificate2.png"),
  },
  {
    id: 3,
    certificateName: "Workplace Fire Safety",
    issueDate: "18 Aug 2024,12:35 PM",
    status: "ACTIVE",
    image: require("assets/img/certificates_templates/certificate3.jpg"),
    fileUrl: require("assets/img/certificates_templates/certificate3.jpg"),
  },
  {
    id: 4,
    certificateName: "Industrial PPE Training",
    issueDate: "02 Mar 2024, 05:15 PM",
    status: "ACTIVE",
    image: require("assets/img/certificates_templates/certificate4.png"),
    fileUrl: require("assets/img/certificates_templates/certificate4.png"),
  },
  {
    id: 5,
    certificateName: "First Aid & Emergency Care",
    issueDate: "15 Jun 2023, 11:53 AM",
    status: "INACTIVE",
    image: require("assets/img/certificates_templates/certificate5.jpg"),
    fileUrl: require("assets/img/certificates_templates/certificate5.jpg"),
  },
  {
    id: 6,
    certificateName: "High Voltage Safety Certification",
    issueDate: "20 Dec 2024, 11:53 AM",
    status: "ACTIVE",
    image: require("assets/img/certificates_templates/certificate1.png"),
    fileUrl: require("assets/img/certificates_templates/certificate1.png"),
  },
  {
    id: 7,
    certificateName: "Advanced Industrial Wiring",
    issueDate: "10 Feb 2023, 11:53 AM",
    status: "INACTIVE",
    image: require("assets/img/certificates_templates/certificate2.png"),
    fileUrl: require("assets/img/certificates_templates/certificate2.png"),
  },
  {
    id: 8,
    certificateName: "Emergency Evacuation Training",
    issueDate: "05 Sep 2024, 10:18 AM",
    status: "ACTIVE",
    image: require("assets/img/certificates_templates/certificate3.jpg"),
    fileUrl: require("assets/img/certificates_templates/certificate3.jpg"),
  },
  {
    id: 9,
    certificateName: "Factory Safety & Compliance",
    issueDate: "18 Apr 2024, 11:53 AM",
    status: "ACTIVE",
    image: require("assets/img/certificates_templates/certificate4.png"),
    fileUrl: require("assets/img/certificates_templates/certificate4.png"),
  },
  {
    id: 10,
    certificateName: "Basic Life Support (BLS)",
    issueDate: "01 Jul 2023, 06:36 PM",
    status: "INACTIVE",
    image: require("assets/img/certificates_templates/certificate5.jpg"),
    fileUrl: require("assets/img/certificates_templates/certificate5.jpg"),
  },
];

const Templates = () => {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    //
    setTimeout(() => {
      setCertificates(certificateList);
      setLoading(false);
    }, 800);
  }, []);

  return (
    <>
      <AdminHeader parentName="Learning" />

      <Container fluid className="profile-page mt--6">
        <Row className="justify-content-center">
          <Col xl="12" lg="10">
            <Card className="certificates-card">
              <CardHeader className="d-flex align-items-center justify-content-between">
                <CardTitle tag="h3" className="mb-0">
                  Templates
                </CardTitle>

                <Button
                  className="btn-deep-blue"
                  onClick={() =>
                    navigate(
                      role === "SUPER_ADMIN"
                        ? "/super-admin/certificate/create-certificate"
                        : "/admin/certificate/create-certificate",
                    )
                  }
                >
                  <i className="fa fa-plus mr-1" />
                  Template
                </Button>
              </CardHeader>
              <CardBody>
                <p className="page-subtitle">
                  View, download, or activate certificates.
                </p>

                {/* LOADING */}
                {loading && (
                  <div className="text-center py-5">
                    <Spinner color="primary" />
                  </div>
                )}

                {/* EMPTY */}
                {!loading && certificates.length === 0 && (
                  <div className="empty-state">
                    <p>No certificates earned yet.</p>
                  </div>
                )}

                {/* GRID */}
                {!loading && certificates.length > 0 && (
                  <Row className="certificates-grid">
                    {certificates.map((item) => (
                      <Col key={item.id} xl="4" lg="6" md="6" className="mb-4">
                        <Card className="certificate-tile">
                          {/* TOP BAR (ABOVE IMAGE) */}
                          <div className="certificate-top-bar">
                            <Badge
                              className="certificate-status"
                              color={
                                item.status === "ACTIVE" ? "success" : "danger"
                              }
                            >
                              {item.status === "ACTIVE" ? "Active" : "INACTIVE"}
                            </Badge>

                            <div className="certificate-actions">
                              <Button
                                size="sm"
                                className="icon-btn"
                                onClick={() =>
                                  window.open(item.fileUrl, "_blank")
                                }
                              >
                                <i className="fa-solid fa-eye" />
                              </Button>

                              <Button
                                size="sm"
                                className="icon-btn"
                                onClick={() =>
                                  window.open(item.fileUrl, "_blank")
                                }
                              >
                                <i className="fa-solid fa-pen-to-square" />
                              </Button>

                              <Button
                                size="sm"
                                className="icon-btn"
                                onClick={() =>
                                  window.open(item.fileUrl, "_blank")
                                }
                              >
                                <i className="fa-solid fa-download" />
                              </Button>
                            </div>
                          </div>

                          {/* IMAGE */}
                          <div className="certificate-image-wrapper">
                            <img
                              src={item.image}
                              alt={item.certificateName}
                              className="certificate-image"
                            />
                          </div>

                          <CardBody className="pb-0">
                            <div className="d-flex justify-content-between align-items-start">
                              {/* <div className="d-flex flex-column align-items-start"> */}
                              <div>
                                <h4 className="certificate-title">
                                  {item.certificateName}
                                </h4>
                                <span className="certificate-date">
                                  Created on {item.issueDate}
                                </span>
                              </div>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Templates;
